// ----以下两个字段每期不同，注意修改
// 活动结束时间，过了这个时间后，IncreProcessModal就不弹出了
export const ACT_END_TIME = '2025-03-31T23:59:59+08:00'; // ISO 8601 格式
// 净增奖发放结束时间
export const REWARD_END_TIME = '2025-04-30T23:59:59+08:00';
